module.exports = __webpack_public_path__ + "static/media/needle.047d988b.png";